import { getOrgMe,refreshToken } from '@/api/auth/index'
import { useCache } from '@/hooks/web/useCache'
import { useAppStore } from '@/store/modules/app'
import { useAuthStoreWithOut } from '@/store/modules/auth';
import { GetAccountMe } from '@/api/apm'
const appStore = useAppStore()
const authStore = useAuthStoreWithOut()
/**
 *
 * @returns any
 */
export const RefreshToken = async () => {
    refreshToken().then((res : any)=>{
        if(res && res.code==0){
            // utils.setCookie('EIToken', res.data.accessToken)
            // utils.setCookie('EIName', utils.getCookie('EIName'))
        }
    })
}

/**
 *
 * @returns any
 */
 export const GetUserInfo = async () => {
    let userInfo:any = {username: sessionStorage.getItem('validUser')}
    const orgInfo:any = {id:1,name:'Main Org.'}
    let roles = []
    const props = window.$wujie?.props
    if(props){
        if (props.userInfo) {
            userInfo = props.userInfo
            roles = userInfo.roles
        } 
        if (props.orgInfo) {
            // authStore.setOrgInfo(window.$wujie.props.orgInfo)
            Object.assign(orgInfo, props.orgInfo)
        }      
    }else{
        const res = await GetAccountMe()
        if(res){
            Object.assign(userInfo, { ...res, username:res.userName })
            roles = res.roles
            // authStore.setTenantId(res.tenantId)
        }
    }
    //判断是否管理员
    if(roles&&roles.length>0){
        const orgId = orgInfo.id
        const obj = roles.find(item=>item.orgId==orgId||item.orgId===0)
        authStore.setRoleInfo(obj)
    }
    authStore.setOrgInfo(orgInfo)
    authStore.setUserInfo(userInfo) 
}

/**
 *
 * @returns any
 */
 export const GetTenantInfo = async () => {
    return new Promise((resolve) => {
        getOrgMe().then((res:any) => {
            if(res && res.code==0) authStore.setOrgInfo(res.data)
            else resolve(res.msg)
        }).finally(() => {
            resolve(null)
        })
    })
    
}

// auth

export const isAdmin = () => {
    return authStore.isAdmin
}
// export const canRead = (routeName:any) => {
//     if (isAdmin()) return true
//     let moduleName = routeName
//     // 隐藏路由需要做特殊处理
//     // template/batch, template/partsin, parts/partsin, parts/partsdetail
//     switch (routeName) {
//         // 批量导入和模板出库的权限需要根据Template决定
//         case 'WarehousingBatch':
//         case 'TemplatePartsIn':
//             moduleName = 'Template'
//             break
//         // 入库和备件详情的权限需要根据Template决定
//         case 'PartsIn':
//         case 'PartsDetail':
//             moduleName = 'PartsList'
//             break
//     }
//     const auth = authStore.getUsersAuthByModule(moduleName)
//     if (auth && auth.read) return true
//     return authStore.getUsersAuthByModule(moduleName).read
// }
// export const canWrite = (routeName:any) => {
//     if (isAdmin()) return true
// }

export const ApplicantLabel = applicant => {
    if (!applicant) return ''
    if (applicant.full_name) return applicant.full_name
    if (applicant.user_name) return applicant.user_name
    return ''
}
// auth